/* Nótt 3D-produktvisning — prosedyrisk modell av Meta Air powerbank */
(function() {
  var modal = document.getElementById('nott-3d-modal');
  if (!modal) return;

  var canvasWrap = document.getElementById('nott-3d-canvas-wrap');
  var loaded = false, scene, camera, renderer, product, animId;
  var targetRX = -0.15, targetRY = 0.5, curRX = -0.15, curRY = 0.5;
  var dragging = false, lastX = 0, lastY = 0, idleTime = 0;

  function loadThree(cb) {
    if (window.THREE) return cb();
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }

  function roundedRectShape(w, h, r) {
    var s = new THREE.Shape();
    s.moveTo(-w/2 + r, -h/2);
    s.lineTo(w/2 - r, -h/2);
    s.quadraticCurveTo(w/2, -h/2, w/2, -h/2 + r);
    s.lineTo(w/2, h/2 - r);
    s.quadraticCurveTo(w/2, h/2, w/2 - r, h/2);
    s.lineTo(-w/2 + r, h/2);
    s.quadraticCurveTo(-w/2, h/2, -w/2, h/2 - r);
    s.lineTo(-w/2, -h/2 + r);
    s.quadraticCurveTo(-w/2, -h/2, -w/2 + r, -h/2);
    return s;
  }

  function buildScene() {
    var w = canvasWrap.clientWidth, h = canvasWrap.clientHeight;
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(32, w / h, 0.1, 50);
    camera.position.set(0, 0, 6.2);

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(w, h);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    canvasWrap.appendChild(renderer.domElement);

    product = new THREE.Group();

    // ── Kropp: 66 × 107 × 9.6 mm → proporsjoner 1.32 × 2.14 × 0.19 ──
    var shape = roundedRectShape(1.32, 2.14, 0.24);
    var geo = new THREE.ExtrudeGeometry(shape, {
      depth: 0.13, bevelEnabled: true, bevelThickness: 0.035,
      bevelSize: 0.035, bevelSegments: 6, curveSegments: 24
    });
    geo.center();
    var bodyMat = new THREE.MeshPhysicalMaterial({
      color: 0x17171b, roughness: 0.42, metalness: 0.28,
      clearcoat: 0.35, clearcoatRoughness: 0.5
    });
    var body = new THREE.Mesh(geo, bodyMat);
    product.add(body);

    // ── Metallramme rundt kanten ──
    var frameShape = roundedRectShape(1.335, 2.155, 0.245);
    var frameHole = roundedRectShape(1.27, 2.09, 0.215);
    frameShape.holes.push(frameHole);
    var frameGeo = new THREE.ExtrudeGeometry(frameShape, {
      depth: 0.155, bevelEnabled: false, curveSegments: 24
    });
    frameGeo.center();
    var frameMat = new THREE.MeshStandardMaterial({
      color: 0x2c2c30, roughness: 0.25, metalness: 0.85
    });
    product.add(new THREE.Mesh(frameGeo, frameMat));

    // ── "Air"-logo: ring øverst til høyre på fronten ──
    var logoMat = new THREE.MeshStandardMaterial({
      color: 0x3a3a40, roughness: 0.3, metalness: 0.9
    });
    var logoRing = new THREE.Mesh(new THREE.TorusGeometry(0.11, 0.012, 12, 40), logoMat);
    logoRing.position.set(0.42, 0.78, 0.102);
    product.add(logoRing);

    // ── Magnetring på baksiden (MagSafe) ──
    var magMat = new THREE.MeshStandardMaterial({
      color: 0x222226, roughness: 0.35, metalness: 0.7
    });
    var magRing = new THREE.Mesh(new THREE.TorusGeometry(0.52, 0.02, 12, 48), magMat);
    magRing.position.set(0, 0.25, -0.102);
    product.add(magRing);

    // ── USB-C-port i bunnen ──
    var portMat = new THREE.MeshStandardMaterial({ color: 0x0a0a0a, roughness: 0.6, metalness: 0.4 });
    var port = new THREE.Mesh(new THREE.CylinderGeometry(0.032, 0.032, 0.34, 16), portMat);
    port.rotation.z = Math.PI / 2;
    port.scale.z = 0.45;
    port.position.set(0, -1.115, 0);
    product.add(port);

    scene.add(product);

    // ── Lys: dempet nøkkellys + gylne kantlys ──
    scene.add(new THREE.AmbientLight(0x404040, 0.55));
    var key = new THREE.DirectionalLight(0xe8e4dc, 0.85);
    key.position.set(2, 3, 4);
    scene.add(key);
    var rimGoldL = new THREE.DirectionalLight(0xb8a882, 1.15);
    rimGoldL.position.set(-4, 1, -2.5);
    scene.add(rimGoldL);
    var rimGoldR = new THREE.DirectionalLight(0x8a7a5a, 0.9);
    rimGoldR.position.set(4, -1.5, -2);
    scene.add(rimGoldR);
    var fill = new THREE.DirectionalLight(0x35506a, 0.35);
    fill.position.set(0, -3, 2);
    scene.add(fill);

    // ── Interaksjon ──
    var el = renderer.domElement;
    el.style.cursor = 'grab';
    el.style.touchAction = 'none';
    el.addEventListener('pointerdown', function(e) {
      dragging = true; idleTime = 0; lastX = e.clientX; lastY = e.clientY;
      el.style.cursor = 'grabbing'; el.setPointerCapture(e.pointerId);
    });
    el.addEventListener('pointermove', function(e) {
      if (!dragging) return;
      targetRY += (e.clientX - lastX) * 0.012;
      targetRX += (e.clientY - lastY) * 0.012;
      targetRX = Math.max(-1.2, Math.min(1.2, targetRX));
      lastX = e.clientX; lastY = e.clientY;
    });
    window.addEventListener('pointerup', function() {
      dragging = false; el.style.cursor = 'grab';
    });

    window.addEventListener('resize', onResize);
  }

  function onResize() {
    if (!renderer || !modal.classList.contains('is-open')) return;
    var w = canvasWrap.clientWidth, h = canvasWrap.clientHeight;
    camera.aspect = w / h; camera.updateProjectionMatrix();
    renderer.setSize(w, h);
  }

  function animate() {
    animId = requestAnimationFrame(animate);
    if (!dragging) {
      idleTime++;
      if (idleTime > 90) targetRY += 0.004; // rolig autorotasjon etter 1,5 s
    }
    curRX += (targetRX - curRX) * 0.08;
    curRY += (targetRY - curRY) * 0.08;
    product.rotation.x = curRX;
    product.rotation.y = curRY;
    renderer.render(scene, camera);
  }

  function open() {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    loadThree(function() {
      if (!loaded) { buildScene(); loaded = true; }
      onResize();
      idleTime = 0;
      animate();
    });
  }

  function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (animId) cancelAnimationFrame(animId);
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-nott-3d-open]')) { e.preventDefault(); open(); }
    if (e.target.closest('[data-nott-3d-close]') || e.target === modal) close();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') close();
  });
})();
